import { MouseEventHandler, ReactNode } from "react";
import { ActionIcon } from "@mantine/core";
import {
  CollapsibleWidthComponent,
  TransitionableComponentProps,
} from "./CollapsibleComponent";
import classes from "./CollapsibleActionIcon.module.css";

interface CollapsibleActionIconProps {
  isOpen: TransitionableComponentProps["isOpen"];
  /** The button's accessible name: the icon has no text, and a tooltip doesn't name it */
  label: string;
  children: ReactNode;
  disabled?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  active?: boolean;
}

export const CollapsibleTopMenuActionIcon = ({
  children,
  isOpen,
  label,
  disabled,
  onClick,
  active,
}: CollapsibleActionIconProps) => {
  return (
    <CollapsibleWidthComponent height={28} width={28} isOpen={isOpen}>
      <ActionIcon
        variant="light"
        disabled={disabled}
        onClick={onClick}
        className={classes.icon}
        mod={{ active }}
        aria-label={label}
        // A toggle (e.g. the measurement) says whether it's on
        aria-pressed={active}
      >
        {children}
      </ActionIcon>
    </CollapsibleWidthComponent>
  );
};
